import React, {forwardRef} from 'react'
import {TwBadge} from './containers'
import {BadgeProps} from './types'

export const Badge = forwardRef(
  (
    {
      type = 'simple',
      variant = 'default',
      size = 16,
      unread = false,
      className,
      children,
      onClick
    }: BadgeProps,
    ref
  ) => (
    <TwBadge
      ref={ref}
      $type={type}
      $variant={variant}
      $size={size}
      $unread={unread}
      className={className}
      onClick={onClick}
    >
      {children}
    </TwBadge>
  )
)
